import React, {Component} from 'react';
import {Form, Control, Errors} from "react-redux-form";
import {/*isEmail,*/ email, /*isRequired,*/ phoneNumber, required} from "../field_validations";
import DatePick from "../forms/datepicker";
import {toInt} from "../parsers";
import _ from "lodash";

export default class AgencyEditForm extends Component{
	render(){
		let {agencies, entities, municipalities, versions} = this.props;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="agencies.edit" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<fieldset className="fieldset">
							<legend>Datos de la instancia</legend>

							<div className="field is-grouped">
								<div className="control">
									<label htmlFor="version_id" className="label">Año <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select
											model=".version_id"
											id="version_id" className="select" errors={{required}} validateOn="change" parser={ toInt }>
											<option value=" " defaultValue>--- Año ---</option>
											{_.map(versions.list,(version, k) => {
												return <option value={version.id} key={k}>{version.year}</option>
											})}
										</Control.select>
									</div>
									<Errors model=".version_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una año.'}} />
								</div>

								<div className="control">
									<label htmlFor="agenciable_type" className="label">Tipo de instancia <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select model=".agenciable_type" id="agenciable_type" changeAction={(m,v) => this._changeAgenciableType(m,v, agencies.edit.agenciable_state_id)} errors={{required}} validateOn="change">
											<option value="" defaultValue>--- Tipo de instancia ---</option>
											<option value="imm">Instituto Municipal de la Mujer</option>
											<option value="imef"> Instancia de la Mujer en la Entidad Federativa</option>
										</Control.select>
									</div>
									<Errors model=".agenciable_type" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar el tipo de meta '}} />
								</div>

								<div className={`control`}>
									<label htmlFor="creation_date" className="label">Fecha de creación </label>
									<Control
										model=".creation_date"
										id="creation_date"
										className={`input`}
										value={agencies.edit.creation_date ? agencies.edit.creation_date:''}
										component={DatePick}/>
									<Errors
										model=".creation_date"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La fecha de creación es obligatoria'}}/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control`}>
									<label htmlFor="agenciable_state_id" className="label">Estado <span className="small has-text-danger">*</span></label>
									<div className={`select`}>
										<Control.select
											model=".agenciable_state_id"
											id="agenciable_state_id"
											value={agencies.edit.agenciable_state_id ? agencies.edit.agenciable_state_id:''}
											changeAction={(model, value) => this._changeAgencyState(model, value, agencies.edit.agenciable_type)}
											parser={toInt}
											errors={{required}}
											validateOn="change"
										>
											<option value="" defaultValue>--- Estado ---</option>
											{_.map(entities.list,(option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
										</Control.select>
									</div>
									<Errors
										model=".agenciable_state_id"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El estado es obligatorio'}}
									/>
								</div>

								{agencies.edit.agenciable_type === 'imm' ?
								<div className="control">
									<label htmlFor="agenciable_municipality_id" className="label">Municipio <span className="small has-text-danger">*</span></label>
									<div className={`select ${agencies.municipalities.isFetching && 'is-loading'}`}>
										<Control.select
											model=".agenciable_municipality_id"
											id="agenciable_municipality_id"
											value={agencies.edit.agenciable_municipality_id ? agencies.edit.agenciable_municipality_id:''}
											errors={{required}}
											validateOn="change"
											disabled={_.isEmpty(agencies.municipalities.list)}>
											<option value="" defaultValue>--- Municipio ---</option>
											{_.map(agencies.municipalities.list,(option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
										</Control.select>
									</div>
									<Errors
										model=".agenciable_municipality_id"
										show="touched"
										wrapper={(props) => <small
											className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El municipio o delegación es obligatorio'}}
									/>
								</div>:''}
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="name" className="label">Nombre de la instancia </label>
									<Control.text
										model=".name"
										id="name"
										autoFocus
										className={`input`}
										placeholder="Nombre de Instancia"/>
									<Errors
										model=".name"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'El nombre de la instancia es obligatorio'}}/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="legal_nature" className="label">Naturaleza jurídica </label>
									<Control.text
										model=".legal_nature"
										id="legal_nature"
										className={`input`}
										placeholder="Naturaleza jurídica"
										value={agencies.edit.legal_nature ? agencies.edit.legal_nature:''}
									/>
									<Errors
										model=".legal_nature"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La naturaleza jurídica de la instancia es obligatorio'}}
									/>
								</div>

								<div className={`control`}>
									<label htmlFor="management_period_start" className="label">Inicio de gestión </label>
									<Control
										model=".management_period_start"
										className={`input`}
										value={agencies.edit.management_period_start ? agencies.edit.management_period_start:''}
										component={DatePick}
									/>
									<Errors
										model=".management_period_start"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La fecha de inicio de gestión es obligatoria'}}
									/>
								</div>

								<div className={`control`}>
									<label htmlFor="management_period_end" className="label">Fin de gestión </label>
									<Control
										model=".management_period_end"
										className={`input`}
										id="management_period_end"
										value={agencies.edit.management_period_end ? agencies.edit.management_period_end:''}
										component={DatePick}
									/>
									<Errors
										model=".management_period_end"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La fecha de fin de gestión es obligatoria'}}
									/>
								</div>
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<legend>Datos generales de la instancia</legend>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="street" className="label">Dirección </label>
									<Control.text
										model=".street"
										id="street"
										className={`input`}
										value={agencies.edit.street ? agencies.edit.street:''}
										placeholder="Calle"
									/>
									<Errors
										model=".street"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La dirección es obligatoria'}}/>
								</div>

								<div className={`control`}>
									<label htmlFor="num_ext" className="label">Número </label>
									<Control.text
										model=".num_ext"
										id="num_ext"
										className={`input`}
										value={agencies.edit.num_ext ? agencies.edit.num_ext:''}
										placeholder="Número exterior"
									/>
									<Errors
										model=".num_ext"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'El número exterior es obligatorio'}}
									/>
								</div>

								<div className={`control`}>
									<label htmlFor="num_int" className="label">Interior </label>
									<Control.text
										model=".num_int"
										type="text"
										id="num_int"
										value={agencies.edit.num_int ? agencies.edit.num_int:''}
										className={`input`}
										placeholder="Número interior"
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="colony" className="label">Colonia </label>
									<Control.text
										model=".colony"
										id="colony"
										className={`input`}
										value={agencies.edit.colony ? agencies.edit.colony:''}
										placeholder="Colonia o Localidad"/>
									<Errors
										model=".colony"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{isRequired: 'La colonia es obligatoria'}}
									/>
								</div>

								<div className={`control`}>
									<label htmlFor="cp" className="label">Código postal </label>
									<Control.text
										model=".cp"
										id="cp"
										className={`input`}
										value={agencies.edit.cp ? agencies.edit.cp:''}
										type="number"
										max="99999"
										step="1"
										min="1"
										placeholder="55555"
									/>
									<Errors
										model=".cp"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El código postal es obligatorio'}}
									/>
								</div>

								<div className={`control`}>
									<label htmlFor="road_type" className="label">Tipo de vialidad </label>
									<Control.text
										model=".road_type"
										id="road_type"
										className={`input`}
										value={agencies.edit.road_type ? agencies.edit.road_type:''}
										placeholder="Tipo de Vialidad"
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control`}>
									<label htmlFor="state_id" className="label">Estado </label>
									<div className={`select`}>
										<Control.select
											model=".state_id"
											id="state_id"
											value={agencies.edit.state_id ? agencies.edit.state_id:''}
											changeAction={(m, v) => this._changeState(m, _.toNumber(v))}
											disabled={entities.isFetching}
										>
											<option value="" defaultValue>--- Estado ---</option>
											{_.map(entities.list,(option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
										</Control.select>
									</div>
									<Errors
										model=".state_id"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El estado es obligatorio'}}
									/>
								</div>

								<div className="control">
									<label htmlFor="municipality_id" className="label">Municipio </label>
									<div className={`select ${municipalities.isFetching && 'is-loading'}`}>
										<Control.select
											model=".municipality_id"
											id="municipality_id"
											value={agencies.edit.municipality_id ? agencies.edit.municipality_id:''}
											disabled={_.isEmpty(municipalities.list)}>
											<option value="" defaultValue>--- Municipio ---</option>
											{_.map(municipalities.list,(option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
										</Control.select>
									</div>
									<Errors
										model=".municipality_id"
										show="touched"
										wrapper={(props) => <small
											className="help has-text-danger">{props.children}</small>}
										messages={{required: 'El municipio o delegación es obligatorio'}}
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="telephone" className="label">Teléfono principal </label>
									<Control.text
										model=".telephone"
										id="telephone"
										className={`input`}
										value={agencies.edit.telephone ? agencies.edit.telephone:''}
										placeholder="Teléfono principal"
										errors={{phoneNumber}}
										validateOn="change"
									/>
									<Errors
										model=".telephone"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{
											isRequired: 'El teléfono es obligatorio',
											phoneNumber: 'El número de teléfono es inválido'
										}}
									/>
								</div>

								<div className={`control is-expanded`}>
									<label htmlFor="telephone_2" className="label">Teléfono alterno</label>
									<Control.text
										model=".telephone_2"
										id="telephone_2"
										className={`input`}
										value={agencies.edit.telephone_2 ? agencies.edit.telephone_2:''}
										placeholder="Teléfono alterno"
										errors={{phoneNumber}}
										validateOn="change"
									/>
									<Errors
										model=".telephone_2"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{
											phoneNumber: 'El número de teléfono es inválido'
										}}
									/>
								</div>
							</div>

							<div className="field is-grouped">
								<div className={`control is-expanded`}>
									<label htmlFor="email" className="label">Email principal</label>
									<Control.text
										model=".email"
										className={`input`}
										value={agencies.edit.email ? agencies.edit.email:''}
										placeholder="Email principal"
										errors={{email}}
										validateOn="change"
									/>
									<Errors
										model=".email"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{
											isRequired: 'El email principal es obligatorio',
											email: 'El email es inválido'
										}}
									/>
								</div>

								<div className={`control is-expanded`}>
									<label htmlFor="email_2" className="label">Email secundario </label>
									<Control.text
										model=".email_2" id="email_2"
										className={`input`}
										value={agencies.edit.email_2 ? agencies.edit.email_2:''}
										placeholder="Email secundario"
										errors={{email}}
										validateOn="change"
									/>
									<Errors
										model=".email_2"
										show="touched"
										wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
										messages={{
											email: 'El email es inválido'
										}}
									/>
								</div>
							</div>
						</fieldset>

						<div className="field is-grouped is-grouped-right" >
							<div className="control">
								<button type="button" className="button is-large"  onClick={() => this.props.history.push('/instancias')}>
									Regresar
								</button>
							</div>

							<div className="control">
								<Control.button
									model="agencies.edit" className="button is-primary is-large" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}

	componentWillMount(){
		const {agencies} = this.props;
		if(!_.isEmpty(agencies.edit) && agencies.edit.state_id){
			this.props.fetchMunicipalities(agencies.edit.state_id);
		}
	}

	_submitForm(values) {
		//console.log('values: ',values);
		this.props.agencyEditSave(values);
	}

	_changeAgenciableType(model,value, state){
		this.props.change(model,value);
		this.props.change('agencies.edit.agenciable_municipality_id', undefined);
		if(value === 'imm' && state){
			this.props.fetchAgencyMunicipalities(state);
		}
	}

	_changeAgencyState(model, value, type) {
		this.props.change(model,value);
		if (value && type === 'imm') {
			this.props.fetchAgencyMunicipalities(value);
		}
	}

	_changeState(model, value) {
		this.props.change(model,value);
		if (value) {
			this.props.fetchMunicipalities(value);
		}
	}

	_validateSave(){
		const {agencies} = this.props;
		let ac = _.find(agencies.permissions, (o) => {return o==='Create'});
		let au = _.find(agencies.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(agencies.edit) && agencies.edit.id){
			if(au){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(agencies.edit) && _.isEmpty(agencies.edit.id)){
			if(ac){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/agencies/form.jsx